import React, { useState, useEffect } from 'react'
import ahilLightMood from '../../image/ahil-lightmood.png';
import ahilDarkMood from '../../image/ahil-darkmood.png';
import ahilLitelLogo from '../../image/ahil_litel_logo.svg';
import appleLittleLogo from '../../image/apple_little_logo.svg';
import playLittleLogo from '../../image/Play-little_logo.svg';
import bazarLittleLogo from '../../image/bazar-little_logo.svg';
import { ThemeContext } from '../../theme/DarkMode';
import '@material/web/button/tonal-button';
import '@material/web/circularprogress/circular-progress.js';
import '@material/web/circularprogress/lib/circular-progress-styles.css';
import Fade from 'react-reveal/Fade';
import { useTranslation } from 'react-i18next';

const OnlineCounter = () => {
    const [count, setCount] = useState(0);
    const targetCount = 8234;
    const { t } = useTranslation();
    
    useEffect(() => {
        // Initial animation from 0 to targetCount
        const duration = 2000;
        const steps = 60;
        const stepDuration = duration / steps;
        const stepSize = targetCount / steps;
        let currentStep = 0;

        const animationInterval = setInterval(() => {
            if (currentStep < steps) {
                setCount(Math.round(stepSize * currentStep));
                currentStep++;
            } else {
                clearInterval(animationInterval);
            }
        }, stepDuration);

        return () => {
            clearInterval(animationInterval);
        };
    }, []);

    return (
        <div className="online-counter">
            <p>{t('header.active-users')}: <span>{count.toLocaleString()}</span></p>
        </div>
    );
};

export const Headr = () => {

    const { theme } = React.useContext(ThemeContext);

    const {t, i18n} = useTranslation()

    // Detect device language and set direction
    React.useEffect(() => {
        const deviceLang = navigator.language || navigator.userLanguage;
        const isRTL = deviceLang.startsWith('fa') || deviceLang.startsWith('ar');
        document.documentElement.dir = isRTL ? 'rtl' : 'ltr';
        document.documentElement.lang = isRTL ? 'fa' : 'en';
    }, []);

    const openInNewTab = (url) => {
        window.open(url, "_blank");
    }

    const downLoadApp = () => {
        openInNewTab("https://www.exontech.ir/download/ahil.apk");
    }

    const openCafebazarVersionVersion = () => {
        openInNewTab("https://cafebazaar.ir/app/com.exon.ahil");
    }

    const openWebVersion = () => {
        openInNewTab("https://web.ahil.app/");
    }

    const openGooglePlay = () => {
        const currentLang = i18n.language;
        const url = currentLang === 'fa' 
            ? "https://play.google.com/store/apps/details?id=com.exon.ahil&hl=fa"
            : "https://play.google.com/store/apps/details?id=com.exon.ahil&hl=en";
        openInNewTab(url);
    }

    React.useEffect(() => {

        const img = new Image();
        img.onload = () => {
            console.log('loaded');
        };
        img.src = ahilDarkMood;

    }, [])



    return (
        <Fade bottom>
            <main className={theme === 'light' ? 'light-header-wrapper' : 'header-wrapper'}>
                <div className='title'>
                    <h1 className='ahil-h'>{t('header.ahil-header')}</h1>
                    <h3 className='header-title'>{t('header.ahil-title')}</h3>
                    <p className='word-piece'>{t("header.word-piece")}</p>
                    <div className='btn-wrapper'>
                        <md-tonal-button aria-label="download google play" onClick={openGooglePlay}>
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                <img src={playLittleLogo} alt="play logo" style={{ 
                                    width: '30px', 
                                    height: '30px', 
                                    ...(i18n.language === 'FA' ? { marginLeft: '4px' } : { marginRight: '4px' })
                                }} />
                                <p>{t('header.google-play-button')}</p>
                            </div>
                        </md-tonal-button>
                        <md-tonal-button aria-label="download cafebazar" onClick={openCafebazarVersionVersion}>
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                <img src={bazarLittleLogo} alt="bazar logo" style={{ 
                                    width: '30px', 
                                    height: '30px', 
                                    ...(i18n.language === 'FA' ? { marginLeft: '4px' } : { marginRight: '4px' })
                                }} />
                                <p>{t('header.cafebazar-button')}</p>
                            </div>
                        </md-tonal-button>
                        <md-tonal-button aria-label="download direct link" onClick={downLoadApp}>
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                <img src={ahilLitelLogo} alt="ahil logo" style={{ 
                                    width: '30px', 
                                    height: '30px', 
                                    ...(i18n.language === 'FA' ? { marginLeft: '4px' } : { marginRight: '4px' })
                                }} />
                                <p>{t('header.direct-link-button')}</p>
                            </div>
                        </md-tonal-button>
                        <md-tonal-button aria-label="open web version" onClick={openWebVersion}>
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                <img src={appleLittleLogo} alt="apple logo" style={{ 
                                    width: '30px', 
                                    height: '30px', 
                                    ...(i18n.language === 'FA' ? { marginLeft: '4px' } : { marginRight: '4px' })
                                }} />
                                <p className='web-version-text'>{t('header.web-version-button')}</p>
                            </div>
                        </md-tonal-button>
                    </div>
                    <OnlineCounter />
                </div>
                <div className='header-menu-content'>
                    {theme === 'light' ?
                        <img src={ahilLightMood} alt='light app ahil' />
                        :
                        <img src={ahilDarkMood} alt='dark app ahil' />
                    }
                </div>
            </main>
        </Fade>
    )
}